/**
 * Class handling element selection in a list
 */
define('commons/element-selector',['jquery', 'utils/set'], function($, Set) {

    var ElementSelectorModel = function() {
        this.selected = new Set();
        this.notSelected = new Set();
        this.allSelected = false;
    };

    ElementSelectorModel.prototype.select = function(element) {
        this.notSelected.remove(element);
        this.selected.add(element);
    };

    ElementSelectorModel.prototype.unselect = function(element) {
        this.selected.remove(element);
        this.notSelected.add(element);
    };

    ElementSelectorModel.prototype.selectElements = function(elements) {
        this.unselectAll();
        for (var i in elements) {
            this.selected.add(elements[i]);
        }
    };

    ElementSelectorModel.prototype.unselectAll = function() {
        this.allSelected = false;
        this.selected.removeAll();
        this.notSelected.removeAll();
    };

    ElementSelectorModel.prototype.selectAll = function() {
        this.allSelected = true;
        this.selected.removeAll();
        this.notSelected.removeAll();
    };

    ElementSelectorModel.prototype.isSelected = function(id) {
        if (this.allSelected) {
            return !this.notSelected.contains(id);
        } else {
            return this.selected.contains(id);
        }
    };

    /**
     * UI component
     */
    var ElementSelector = function(container, options) {
        this.model = new ElementSelectorModel();
        this.$container = $(container);

        this.settings = $.extend({
            selectAll : '#selectAll',
            unselectAll : '#unselectAll',
            selectAllOnPage : '#selectAllOnPage',
            suffix : ''
        }, options);

        this.$container.find(this.settings.selectAll+this.settings.suffix).click($.proxy(this.onSelectAll, this));
        this.$container.find(this.settings.unselectAll+this.settings.suffix).click($.proxy(this.onUnselectAll, this));
        this.$container.find(this.settings.selectAllOnPage+this.settings.suffix).click($.proxy(this.onSelectAllOnPage, this));
    };

    ElementSelector.prototype.beforeDataLoaded = function() {
        this._findCheckboxes().unbind('click');
    };

    ElementSelector.prototype.onDataLoaded = function() {
        if ($("#selectAllOnPage").length !==0 && this.settings.suffix !== ''){
            $("#selectAllOnPage").attr("id", "selectAllOnPage" + this.settings.suffix);
        }
        this.$container.find(this.settings.selectAllOnPage+this.settings.suffix).click($.proxy(this.onSelectAllOnPage, this));
        var checkeds = 0; 
        this._findCheckboxes().each($.proxy(function(index, element) {
            var $elt = $(element);
            if (this.model.isSelected($elt.data('id'))) {
                $elt.prop('checked', true);
                checkeds ++;
            } else {
                $elt.prop('checked', false);
            }
        }, this));
        if (this._findCheckboxes().length == checkeds){
            this.$container.find(this.settings.selectAllOnPage+this.settings.suffix).prop('checked', true);
        } else {
            this.$container.find(this.settings.selectAllOnPage+this.settings.suffix).prop('checked', false);
        }
        this._findCheckboxes().click($.proxy(this.onCheckboxClick, this));
    };

    ElementSelector.prototype.onCheckboxClick = function(event) {
        var elt = $(event.currentTarget);
        if (elt.is(':checked')) {
            this.model.select(elt.data('id'));
        } else {
            this.model.unselect(elt.data('id'));
        }
    };

    ElementSelector.prototype.unselectAll = function() {
        this.model.unselectAll();
        this.$container.find(this.settings.selectAllOnPage+this.settings.suffix).prop('checked', false);
        this._findCheckboxes().each(function(index, checkbox) {
            $(checkbox).prop('checked', false);
        });
    };

    ElementSelector.prototype.selectAll = function() {
        this.model.selectAll();
        this.$container.find(this.settings.selectAllOnPage+this.settings.suffix).prop('checked', true);
        this._findCheckboxes().each(function(index, checkbox) {
            $(checkbox).prop('checked', true);
        });
    };

    ElementSelector.prototype.onUnselectAll = function() {
        if (confirm("You are about to unselect all your elements. Continue?")) {
            this.unselectAll();
        }
    };

    ElementSelector.prototype.onSelectAll = function() {
        if (confirm("You are about to select all the elements. Continue?")) {
            this.selectAll();
        }
    };

    ElementSelector.prototype.onSelectAllOnPage = function() {
        var checked = this.$container.find(this.settings.selectAllOnPage+this.settings.suffix).is(':checked');
        this._findCheckboxes().each($.proxy(function(index, checkbox) {
            var $checkbox = $(checkbox);
            $checkbox.prop('checked', checked);
            if (checked){
                this.model.select($checkbox.data('id'));
            }else{
                this.model.unselect($checkbox.data('id'));
            }
        }, this));
    };

    ElementSelector.prototype._findCheckboxes = function() {
        return this.$container.find('input[type=checkbox]:not('+(this.settings.selectAllOnPage+this.settings.suffix)+')');
    };

    return ElementSelector;
});

